export const RESET_CUSTOMER_ADDRESS_ISFETCHING =
  'RESET_CUSTOMER_ADDRESS_ISFETCHING';
export const GET_CUSTOMER_ADDRESS_SUCCESS = 'GET_CUSTOMER_ADDRESS_SUCCESS';
export const LIST_CUSTOMER_ADDRESSES_REQUEST =
  'LIST_CUSTOMER_ADDRESSES_REQUEST';
export const LIST_CUSTOMER_ADDRESSES_SUCCESS =
  'LIST_CUSTOMER_ADDRESSES_SUCCESS';
export const CUSTOMER_ADDRESS_LIST_REQUESTING =
  'CUSTOMER_ADDRESS_LIST_REQUESTING';
export const CUSTOMER_ADDRESS_OBJECT_REQUESTING =
  'CUSTOMER_ADDRESS_OBJECT_REQUESTING';
export const ADD_CUSTOMER_ADDRESS_REQUEST = 'ADD_CUSTOMER_ADDRESS_REQUEST';
export const EDIT_CUSTOMER_ADDRESS_REQUEST = 'EDIT_CUSTOMER_ADDRESS_REQUEST';
export const DELETE_CUSTOMER_ADDRESS_REQUEST =
  'DELETE_CUSTOMER_ADDRESS_REQUEST';
export const DELETE_CUSTOMER_ADDRESS_SUCCESS =
  'DELETE_CUSTOMER_ADDRESS_SUCCESS';
